<script setup lang="ts">
import { NavigationMenuItem, NavigationMenuLink } from "reka-ui";
import type { RouterLinkProps } from "vue-router";

defineOptions({ inheritAttrs: false });

const props = defineProps<RouterLinkProps>();
</script>

<template>
	<NavigationMenuItem as="li">
		<NavigationMenuLink asChild>
			<RouterLink v-bind="{ ...props, ...$attrs }">
				<slot />
			</RouterLink>
		</NavigationMenuLink>
	</NavigationMenuItem>
</template>
